import React from 'react';

import { Form, Input, Modal } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useIntl } from 'react-intl';

import styled from 'styled-components';
import { useUpdateProductSmidMutation } from '../../../../../stores/productsSlice';

interface UpdateSmidModalProps {
  accountId: string;
  product: { id: string; providerId: string; externalId: string };
  onClose: () => void;
}

const ContentDiv = styled.div`
  label::before {
    content: '* ';
    color: red;
    padding-right: 0.3em;
  }
`;

const ErrorDiv = styled.div`
  color: red;
`;

export interface UpdateSMIDModalMessages {
  title: string;
  message: string;
  errorMessage: string;
  SMIDRequiredMessage: string;
  okButtonMessage: string;
  cancelButtonMessage: string;
  SMIDPlaceholder: string;
}

const UpdateSmidModal: React.FC<UpdateSmidModalProps> = (props: UpdateSmidModalProps) => {
  const { messages } = useIntl();
  const [updateProductSmid, { isLoading: isEditing, isError, isSuccess }] = useUpdateProductSmidMutation();
  const [form] = useForm();

  const editProductMessages = messages.updateSMIDModal as unknown as UpdateSMIDModalMessages;

  if (isSuccess) {
    props.onClose();

    return <></>;
  }

  return (
    <Modal
      visible={true}
      title={editProductMessages.title}
      width="520px"
      okText={editProductMessages.okButtonMessage}
      cancelText={editProductMessages.cancelButtonMessage}
      centered={true}
      okButtonProps={{ loading: isEditing }}
      onCancel={props.onClose}
      onOk={form.submit}
    >
      <Form
        form={form}
        layout="vertical"
        // initialValues={}
        onFinish={async (values) => {
          await updateProductSmid({
            accountId: props.accountId,
            providerId: props.product.providerId,
            productASIN: props.product.externalId,
            smid: values.smid,
          });
        }}
      >
        <ContentDiv>
          <Form.Item
            label={editProductMessages.message}
            name="smid"
            rules={[{ required: true, message: editProductMessages.SMIDRequiredMessage }]}
          >
            <Input size="large" placeholder={editProductMessages.SMIDPlaceholder} />
          </Form.Item>

          {isError && <ErrorDiv>{editProductMessages.errorMessage}</ErrorDiv>}
        </ContentDiv>
      </Form>
    </Modal>
  );
};

export default UpdateSmidModal;
